module.exports = __webpack_public_path__ + "assets/img/mecha-a4f2df28.png";